@if (canAcceptValidation) {
  <button mat-icon-button matTooltip="Accepter la validation" (click)="acceptValidation()">
    <mat-icon class="success">playlist_add_check</mat-icon>
  </button>
}
